import { useBasePath } from "../useBasePath";

/**
 * @returns default query params for the secrets page, which changes based on if
 * the user has the new secrets UI or not.
 */
export const useSecretsPageUrl = () => {
  const basePath = useBasePath();
  const params = new URLSearchParams();

  params.set(
    "validation_state",
    "confirmed_valid,validation_error,no_validator"
  );
  params.set("tab", "open");

  return new URL(
    `${basePath}/secrets?${params.toString()}`,
    window.location.origin
  );
};
